export default __webpack_public_path__ + "static/media/marker.694aab17.svg";